import { Offering } from '@arrived/models';

import { canOfferingStatusReserveShares } from './canOfferingStatusReserveShares';

export const isRemainingSharesLessThanMinimumActionableShares = (offering: Offering): boolean => {
  const { status, totalSharesReserved, totalSharesTransacted, totalShares, sharePrice, minTransactionAmount } =
    offering;

  const totalActionableShares = canOfferingStatusReserveShares(status) ? totalSharesReserved : totalSharesTransacted;
  const remainingSharesCount = Math.max(0, totalShares - totalActionableShares);
  const minActionableSharesCount = Math.floor(minTransactionAmount / sharePrice);

  return remainingSharesCount < minActionableSharesCount;
};
